import React from "react";

// Components
import TemplateArticle from './TemplateArticleGlobal';

const TemplateVideo = ({_uid}) => {
    return <TemplateArticle contentType="node--article_video" _uid={_uid}/>
};

export default TemplateVideo;